<template>
    <el-badge :value="unReadCount" :hidden="(unReadCount < 1)">
        <div class="icon-comment" @click="goToRong"></div>
    </el-badge>
    <div class="tips" v-if="unReadCount > 0">{{unReadCount}}条未读私信</div>
    <div class="tips" v-else>私信</div>
</template>

<script>
import domain from '@/service/domain'
import * as RongIMLib from '@rongcloud/imlib-next'
import { mapState, mapActions } from 'vuex'
export default {
    computed: {
        ...mapState({
            userId: state => state.user.userId,
            rongYunToken: state => state.im.rongYunToken,
            unReadCount: state => state.im.unReadCount,
            connected: state => state.im.connected,
        }),
        appkey(){
            return /test/.test(location.host) ? this.$store.state.im.appkeyTest : this.$store.state.im.appkey;
        },
    },
    data() {
        return {}
    },
    async created() {
        if (this.userId && !this.rongYunToken) {
            await this.getImToken(this.userId)
            if (this.rongYunToken){
                if(this.connected){
                    this.getTotalUnReadCount();
                }else{
                    RongIMLib.init({ appkey: this.appkey });
                    const Events = RongIMLib.Events

                    /**
                     * 手动调用 disconnect 方法或者用户被踢下线 会触发这个事件
                     */
                    RongIMLib.addEventListener(Events.DISCONNECT, (code) => {
                        console.log('连接中断，需要业务层进行重连处理 ->', code)
                        this.$store.dispatch("currentConnectedAction", false);
                    })

                    /**
                     * 链接出问题时，内部进行重新链接，会触发这个事件
                     */
                    RongIMLib.addEventListener(Events.SUSPEND, (code) => {
                        console.log('链接中断，SDK 会尝试重连，业务层无需关心')
                        // 5.1.2 版本开始，事件回调中会引起中断的 code 状态码
                        console.log(`code -> ${code}`)
                    })

                    RongIMLib.addEventListener(Events.CONNECTING, function() {
                        console.log('正在链接服务器')
                    })

                    RongIMLib.addEventListener(Events.CONNECTED, () => {
                        console.log('已经链接到服务器')
                        this.$store.dispatch("currentConnectedAction", true);
                    })
                    // 接收消息监听器
                    RongIMLib.addEventListener(Events.MESSAGES, (evt) => {
                        let message = evt.messages[0];
                        console.log('收到新消息', message);
                        this.getTotalUnReadCount();
                    })
                    RongIMLib.connect(this.rongYunToken).then(res => {
                        if (res.code === RongIMLib.ErrorCode.SUCCESS) {
                            console.log('链接成功, 链接用户 id 为: ', res.data.userId);
                            this.getTotalUnReadCount()
                        } else {
                            console.warn('链接失败, code:', res.code)
                        }
                    })
                }
                
            }
        }
    },
    methods: {
        ...mapActions({
            getImToken: "getImToken",
        }),
        getTotalUnReadCount(){
            const conversationTypes = [RongIMLib.ConversationType.PRIVATE, RongIMLib.ConversationType.GROUP]
            RongIMLib.getTotalUnreadCount(true, conversationTypes).then(res => {
                if (res.code === 0) {
                    console.log(res.code, res.data)
                    this.$store.dispatch("currentUnReadCountAction", res.data);
                } else {
                    console.log(res.code, res.msg)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        goToRong(){
            let newTab = window.open('about:blank');
            newTab.location.href = `${domain.account}/RongIM`
        },
    }
}
</script>

<style scoped lang="scss">
.icon {
    cursor: pointer;
    &.iconMessage {
        position: relative;
        .icon-comment{
            font-size: 25px;
        }
        .tips {
            white-space: nowrap;
            font-size: 12px;
            border-radius: 2px;
            background-color: #1A1A1A;
            color: #fff;
            line-height: 1;
            padding: 3px 5px 5px;
            position: absolute;
            left: 50%;
            top: 26px;
            transform: translateX(-50%);
            display: none;
        }
        &:hover {
            .tips {
                display: block;
            }
        }
    }
}
</style>
